<template>

    <v-dialog v-model="showDialog" max-width="300" v-if="Object.keys(detailData).length !== 0 && detailData.constructor !== Object" class="semi-transparent-5-bg">

        <v-card class="semi-transparent-7-bg">

            <v-list class="semi-transparent-7-bg">

                <v-list-tile>

                    <v-list-tile-avatar>

                        <v-icon class="lighten-1 white--text">far fa-id-badge</v-icon>

                    </v-list-tile-avatar>

                    <v-list-tile-content>

                        <v-list-tile-sub-title> {{ $t( 'miniGame.id' ) }} </v-list-tile-sub-title>

                        <v-list-tile-title>{{ detailData[0].id }}</v-list-tile-title>

                    </v-list-tile-content>

                </v-list-tile>

                <v-divider ::inset="true"></v-divider>

                <v-list-tile>

                    <v-list-tile-avatar>

                        <v-icon class="lighten-1 white--text">fas fa-dice</v-icon>

                    </v-list-tile-avatar>

                    <v-list-tile-content>

                        <v-list-tile-sub-title> {{ $t( 'miniGame.game' ) }} </v-list-tile-sub-title>

                        <v-list-tile-title>{{ detailData[0].gameName }}</v-list-tile-title>

                    </v-list-tile-content>

                </v-list-tile>

                <v-divider :inset="true"></v-divider>

                <v-list-tile>

                    <v-list-tile-avatar>

                        <v-icon xs class="lighten-1 white--text">fa fa-trophy</v-icon>

                    </v-list-tile-avatar>

                    <v-list-tile-content>

                        <v-list-tile-sub-title> {{ $t( 'miniGame.prizeName' ) }} </v-list-tile-sub-title>

                        <v-list-tile-title>{{ detailData[0].name }}</v-list-tile-title>

                    </v-list-tile-content>

                </v-list-tile>

                <v-divider :inset="true"></v-divider>

                <v-list-tile>

                    <v-list-tile-avatar>

                        <v-icon xs class="lighten-1 white--text">far fa-list-alt</v-icon>

                    </v-list-tile-avatar>

                    <v-list-tile-content>

                        <v-list-tile-sub-title> {{ $t( 'miniGame.category' ) }}</v-list-tile-sub-title>

                        <v-list-tile-title>{{ detailData[0].category }}</v-list-tile-title>

                    </v-list-tile-content>

                </v-list-tile>

                <v-list-tile>

                    <v-list-tile-avatar>

                        <v-icon xs class="lighten-1 white--text">fas fa-dollar-sign</v-icon>

                    </v-list-tile-avatar>

                    <v-list-tile-content>

                        <v-list-tile-sub-title> {{ $t( 'miniGame.amount' ) }}</v-list-tile-sub-title>

                        <v-list-tile-title>{{ detailData[0].amount }}</v-list-tile-title>

                    </v-list-tile-content>

                </v-list-tile>

                <v-divider :inset="true"></v-divider>

                <v-list-tile >

                    <v-list-tile-avatar>

                        <v-icon xs class="lighten-1 white--text">fas fa-clipboard-check</v-icon>

                    </v-list-tile-avatar>

                    <v-list-tile-content>

                        <v-list-tile-sub-title> {{ $t( 'miniGame.status' ) }} </v-list-tile-sub-title>

                        <v-list-tile-title v-html="getStatusText(detailData[0])"></v-list-tile-title>

                    </v-list-tile-content>

                </v-list-tile>

                <v-divider :inset="true"></v-divider>

                <v-list-tile >

                    <v-list-tile-avatar>

                        <v-icon xs class="lighten-1 white--text">fas fa-calendar</v-icon>

                    </v-list-tile-avatar>

                    <v-list-tile-content>

                        <v-list-tile-sub-title> {{ $t( 'miniGame.created_at' ) }} </v-list-tile-sub-title>

                        <v-list-tile-title>{{ detailData[0].created_at}}</v-list-tile-title>

                    </v-list-tile-content>

                </v-list-tile>

                <v-divider :inset="true"></v-divider>

                <v-list-tile >

                    <v-list-tile-avatar>

                        <v-icon xs class="lighten-1 white--text">fas fa-calendar-minus</v-icon>

                    </v-list-tile-avatar>

                    <v-list-tile-content>

                        <v-list-tile-sub-title> {{ $t( 'miniGame.expiry_date' ) }} </v-list-tile-sub-title>

                        <v-list-tile-title>{{ detailData[0].expiry_date == '' ? '-' : detailData[0].expiry_date }}</v-list-tile-title>

                    </v-list-tile-content>

                </v-list-tile>

                <v-divider :inset="true"></v-divider>

                <v-list-tile >

                    <v-list-tile-avatar>

                        <v-icon xs class="lighten-1 white--text">fas fa-clock</v-icon>

                    </v-list-tile-avatar>

                    <v-list-tile-content>

                        <v-list-tile-sub-title> {{ $t( 'miniGame.claimable_days' ) }} </v-list-tile-sub-title>

                        <v-list-tile-title v-html="getClaimableText(detailData[0])"></v-list-tile-title>

                    </v-list-tile-content>

                </v-list-tile>

            </v-list>

            <v-divider></v-divider>

            <v-card-actions class="semi-transparent-7-bg">

                <v-btn color="green" flat="flat" @click="showDialog = false"> {{ $t( 'reusable.close' ) }} </v-btn>

                <v-spacer></v-spacer>

            </v-card-actions>

        </v-card>

    </v-dialog>

</template>

<style scoped>
    hr {
        margin-top: 0px !important;
        margin-bottom: 0px !important;
    }

    div.v-list__tile {
        height: 55px !important;
    }

    .v-list__tile__sub-title {
        font-size: 12px;
    }

    .v-list__tile__title {
        font-size: 16px;
    }
</style>

<script>
export default {
    props: ['dialog', 'detail'],
    data() {
        return {
            showDialog: this.dialog,
            detailData: this.detail
        };
    },
    methods: {
         getStatusText: function(prize) {

            if (prize.status == 'Unclaim') {

                if(prize.ticket_id) {

                    return this.$t('history.processing' );
                }

                return  '<strong class="text-danger">' + this.$t( 'miniGame.unclaim' ) + '</strong>';

            } else if (prize.status == 'Claim') {

                return '<strong class="text-success">' + this.$t( 'miniGame.claim' ) + '</strong>';
            }

            return status;
        },
        getClaimableText: function(prize) {

            if(prize.status == 'Claim') {

                return this.$t( 'miniGame.claim' );

            } else {

                if(prize.claimable_days == '') {

                    return '-';
                } else {

                    if(prize.claimable_days > 0) {

                        return prize.claimable_days;

                    } else {

                        return  this.$t( 'miniGame.expired');
                    }
                }
            }
        }
    },
    watch: {
        dialog(newValue) {
            return this.showDialog = newValue;
        },
        detail(newValue) {
            return this.detailData = newValue;
        },
        showDialog: function(newValue) {
            if (newValue == false) {
                this.$emit('close-dialog')
            }
        }
    }
};
</script>